import { render } from "./ResetPassword.vue?vue&type=template&id=7faadd0e"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=7faadd0e&lang=css"
script.render = render

export default script